import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AsyncState.module.css';

export function SupportAction({phone = import.meta.env.VITE_DNM_SUPPORT_PHONE ?? ''}: {phone?: string}) {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');
  if (!/^\+[1-9][0-9]{7,14}$/.test(phone)) return null;
  async function copy() {
    try { await navigator.clipboard.writeText(phone); setMessage('Number copied'); }
    catch { setMessage('Select and copy the number above.'); }
  }
  return <div className={styles.support}>
    <a href={`tel:${phone}`}>{t('ui.supportAction.call')}</a>
    <span>{phone}</span><button onClick={() => void copy()}>{t('ui.supportAction.copy')}</button>
    {message && <span role="status">{message}</span>}
  </div>;
}
